import { Link as RouterLink } from 'react-router-dom'
import styled from 'styled-components'

import { Button, Link } from '@procsea/design-system'

export const InlinedInputsContainer = styled.div`
  display: flex;

  & > * {
    width: 50%;
  }

  & > *:not(:last-child) {
    margin-right: ${props => props.theme.spacings.medium};
  }
`

export const TermsOfUseLabelContainer = styled.div`
  display: flex;
`

export const CustomizableLink = styled(Link)<{ color?: string | null }>`
  ${props => props.color && `color: ${props.color};`}

  &:hover {
    ${props => props.color && `color: ${props.color};`}
  }
`

export const CustomizableButton = styled(Button)<{ backgroundColor?: string | null }>`
  ${props => props.backgroundColor && `background-color: ${props.backgroundColor};`}

  &:hover {
    ${props => props.backgroundColor && `background-color: ${props.backgroundColor};`}
  }
`

export const StyledRouterLink = styled(RouterLink)`
  text-decoration: underline;
`
